import { FC, HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";
import { ListItem, ListItemIcon, ListItemText, SvgIcon, ListItemSecondaryAction, IconButton, Chip } from "@mui/material";
import { SvgIconComponent } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { ResourceType } from "../../../services/types";
import { SEARCH_ACCELERATORS } from "./config";
type GlobalSearchItemProps = HTMLAttributes<HTMLLIElement> & {
  text: string;
  icon: SvgIconComponent;
  isRemovable?: boolean;
  onRemove?: (keyword: string) => void;
  searchAccelerator?: ResourceType | null;
};
export const GlobalSearchItem: FC<GlobalSearchItemProps> = ({
  text,
  icon,
  isRemovable = false,
  onRemove,
  searchAccelerator,
  ...props
}) => {
  const {
    t
  } = useTranslation();
  const onRequestRemove = () => {
    if (!onRemove) {
      return;
    }

    // Makes sure that we're removing the exact option containing the
    // search accelerator if it was saved with it.
    if (searchAccelerator) {
      onRemove(`[in:${searchAccelerator}] ${text}`);
    } else {
      onRemove(text);
    }
  };
  return <ListItem {...props} sx={{
    "&.MuiAutocomplete-option": {
      px: 2,
      py: 0.5
    },
    minHeight: "36px",
    "&.Mui-focused": {
      borderLeft: theme => "4px solid " + theme.palette.primary.main,
      py: 0.5,
      pr: 2,
      pl: 1.5
    },
    "& + .MuiListItemSecondaryAction-root": {
      display: "none"
    },
    "&.Mui-focused + .MuiListItemSecondaryAction-root": {
      display: "block"
    }
  }} data-sentry-element="ListItem" data-sentry-component="GlobalSearchItem" data-sentry-source-file="GlobalSearchItem.tsx">
      <ListItemIcon sx={{
      width: "32px",
      minWidth: "32px"
    }} data-sentry-element="ListItemIcon" data-sentry-source-file="GlobalSearchItem.tsx">
        <SvgIcon component={icon} fontSize="small" data-sentry-element="SvgIcon" data-sentry-source-file="GlobalSearchItem.tsx" />
      </ListItemIcon>
      {Boolean(searchAccelerator) && <Chip variant="filled" color="primary" size="small" label={`in: ${searchAccelerator ? t(SEARCH_ACCELERATORS[searchAccelerator].textKey) : ""}`} sx={{
      mr: 1
    }} />}
      <ListItemText primary={text} primaryTypographyProps={{
      variant: "body2",
      color: "text.secondary"
    }} data-sentry-element="ListItemText" data-sentry-source-file="GlobalSearchItem.tsx" />
      {isRemovable && <ListItemSecondaryAction>
          <IconButton data-cy="RemoveRecentSearchKeyword" size="small" onClick={onRequestRemove}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </ListItemSecondaryAction>}
    </ListItem>;
};